import React from 'react';

import { Box } from '_lib/components/Box/Box';
import { ExternalLinkOrDefault } from '_lib/components/ExternalLinkOrDefault/ExternalLinkOrDefault';
import { Markup } from '_lib/components/Markup/Markup';
import { Stack } from '_lib/components/Stack/Stack';
import { CompanyLabels } from '_lib/constants/company.constants';
import { HeaderBox } from '_lib/featureComponents/HeaderBox/HeaderBox';

import { CompanyContext, ZoneZipContext } from '../Company.slice';
import { FormattedContactBlock } from '../FormattedContactBlock/FormattedContactBlock';
import { zonedCompanyWithoutZoneSelectedWarning, zonedTooltipText } from '../ZoneOverrideUtils/ZoneOverrideUtils';

export interface CompanyContactProps {
  companyContext: CompanyContext;
  zoneZipContext: ZoneZipContext | undefined;
}

export const CompanyContact = (props: CompanyContactProps): React.ReactElement => {
  const { companyContext, zoneZipContext } = props;
  const { company } = companyContext;

  const headerTooltipText = zonedTooltipText(company);
  const companyWithoutZoneSelectedWarning = zonedCompanyWithoutZoneSelectedWarning(
    company,
    zoneZipContext?.selectedZone
  );

  const contactScheduleUrl =
    (company.isZoned && zoneZipContext?.selectedZone?.contactScheduleUrl) || company.contactScheduleUrl;
  return (
    <Box sx={{ px: 3, py: 2 }}>
      <Stack spacing={4}>
        <Stack direction='row' spacing={2} sx={{ justifyContent: 'flex-start' }}>
          <HeaderBox headerText='PRIMARY CONTACT' infoIconText={headerTooltipText || undefined} sx={{ width: '50%' }}>
            {companyWithoutZoneSelectedWarning || (
              <FormattedContactBlock
                contact={
                  company.isZoned ? zoneZipContext?.selectedZone?.primaryContact || null : company.primaryContact
                }
              />
            )}
          </HeaderBox>
          <HeaderBox headerText='SECONDARY CONTACT' infoIconText={headerTooltipText || undefined} sx={{ width: '50%' }}>
            {companyWithoutZoneSelectedWarning || (
              <FormattedContactBlock
                contact={
                  company.isZoned ? zoneZipContext?.selectedZone?.secondaryContact || null : company.secondaryContact
                }
              />
            )}
          </HeaderBox>
        </Stack>
        <Stack>
          <HeaderBox headerText='Contact Schedule URL' infoIconText={headerTooltipText || undefined}>
            <ExternalLinkOrDefault url={contactScheduleUrl} label={CompanyLabels.CONTACT_SCHEDULE_URL} />
          </HeaderBox>
          <HeaderBox headerText='ON CALL' infoIconText={headerTooltipText || undefined}>
            <HeaderBox headerText='Instructions'>
              {companyWithoutZoneSelectedWarning || (
                <Markup
                  typographyProps={{ sx: { whiteSpace: 'pre-line', overflowWrap: 'break-word' } }}
                  content={
                    company.isZoned ? zoneZipContext?.selectedZone?.onCallNotes || 'N/A' : company.onCallNotes || 'N/A'
                  }
                />
              )}
            </HeaderBox>
          </HeaderBox>
        </Stack>
      </Stack>
    </Box>
  );
};
